// Others
import { db } from '@/config/firebase';


function generateQuery(filter) {
    let query = db.collection("userSessions");

    if (filter.fromTimestamp && filter.fromTimestamp > 0) {
        query = query.where("dateLoggedIn", ">=", filter.fromTimestamp);
    }

    if (filter.toTimestamp && filter.toTimestamp > 0) {
        query = query.where("dateLoggedIn", "<=", filter.toTimestamp);
    }

    if (filter.company && filter.company.id && filter.company.id.length > 0) {
        query = query.where("companyId", "==", filter.company.id);
    }

    if (filter.deviceType && filter.deviceType.length > 0) {
        query = query.where("deviceType", "==", filter.deviceType);
    }

    if (filter.email && filter.email.length > 0) {
        query = query.where("emailAddress", "==", filter.email);
    }

    query = query.orderBy("dateLoggedIn", "desc");

    return query;
}

async function getUserSessions(filterBy) {
    let queryRef = generateQuery(filterBy);

    return queryRef.get().then(function (querySnapshot) {
        let userSessions = {}
        querySnapshot.forEach(function (doc) {
            let userSession = doc.data();
            userSession['id'] = doc.id;
            userSessions[doc.id] = userSession;
        });
        return {
            isSuccess: true,
            userSessions: userSessions
        };
    }).catch((error) => {
        return {
            isSuccess: false,
            error: error
        };
    })
}

function getUserSessionListener(filter, callback) {
    let query = generateQuery(filter);
    let listener = query.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
            callback(change.type, change.doc.data());
        });
    });
    return listener;
}

export default {
    getUserSessions,
    getUserSessionListener
}